var m = require('mithril');
var prop = require('mithril/stream');
var moment = require('moment');
var loaders = require('../layout/components/loaders');
var header = require('../layout/components/header');
var edit = require('../layout/components/edit');
var heading = require('../components/heading');
var button = require('../components/button');
var loadingModal = require('../dashboards/loadingModalORReport');
var downloadFile = require('../layout/components/downloadFile');
var Model = require('../libs/Model');
var modal = require('../layout/components/modal');
var modalForm = require('../layout/components/modalForm');
var Report = Object.assign(require('../../../../models/reports/report'), Model);
var reportForm = modalForm(Report);
var scheduledReportModal = require('./scheduledReportModal');
var auth = require('../auth/models/session');
var downloadReportModalInterface = require('../layout/components/downloadReportModalInterface');
var rowActionDropdown = require('../components/rowActionDropdown');
var requestStatusHandler = require('../layout/components/requestStatusHandler');
var RequestStatus = require('../layout/enums/RequestStatus');

var reports = {};
var DEFAULT_SCHEDULE_SPAN = 30;
var DEFAULT_SCHEDULE_RESAMPLE = 'days';

function downloadResponseFiles(res) {
  var files = res && Array.isArray(res.files) && res.files.length
    ? res.files
    : [{ filename: res && res.filename, downloadUrl: res && res.downloadUrl }];
  return files.filter(function (file) {
    return file && file.filename;
  }).reduce(function (promise, file) {
    return promise.then(function () {
      return downloadFile(file.downloadUrl || ('/report/download/' + file.filename), {
        filename: file.filename
      });
    });
  }, Promise.resolve());
}

function loadReportTypes() {
  return loaders.requestWithLoader({
    loader: 'background',
    url: '/api/v1/report/types',
    method: 'GET',
    background: true
  })
  .then(function (result) {
    if (result) {
      Report.applyRegistryPayload(result);
    }
    return result;
  })
  .catch(function () {
    return null;
  });
}

reports.oninit = function() {
  var ctrl = this;
  document.title = 'nimrod | Reports';
  header.vm.activeTab('Reports');
  ctrl.reportTypesPromise = loadReportTypes();
  ctrl.requestStatus = prop(RequestStatus.PENDING);
  ctrl.requestStatusCode = prop();
  
  ctrl.init = function () {
    ctrl.reportFolderRid = m.route.param('id');
    ctrl.reportFolder = undefined;
    ctrl.requestStatus(RequestStatus.PENDING);
    ctrl.requestStatusCode();
    loaders.requestWithLoader({
      url: "api/v1/reportfolder/" + ctrl.reportFolderRid,
      method: "GET",
      extract: function(xhr) {
        var response = {
          status: xhr.status,
          body: xhr.responseText ? JSON.parse(xhr.responseText) : null
        };
        if (xhr.status < 200 || xhr.status >= 300) {
          throw {response: response};
        }
        return response.body;
      }
    }).then(function(result) {
      ctrl.reportFolder = result;
      ctrl.requestStatus(RequestStatus.SUCCESS);
      m.redraw();
    }).catch(function (error) {
      console.error('Error fetching report folder data:', error);
      ctrl.requestStatusCode(error && (error.status || error.code || (error.response && error.response.status)));
      ctrl.requestStatus(RequestStatus.ERROR);
      m.redraw();
    })
  }
  ctrl.init();
  modal.on('closed', ctrl.init);
}

reports.onupdate = function () {
  var ctrl = this;
  if (ctrl.reportFolderRid != m.route.param('id')) {
    ctrl.init();
  }
}

reports.onremove = function(vnode) {
  modal.off('closed', this.init);
}

function parseEventConfig(value) {
  if (!value) return {};
  if (typeof value === 'string') {
    try {
      return JSON.parse(value) || {};
    } catch (e) {
      return {};
    }
  }
  return (value && typeof value === 'object') ? value : {};
}

function hasEnabledEventConfig(report) {
  var eventConfig = parseEventConfig(report && report.eventConfig);
  return Boolean(eventConfig && eventConfig.enabled);
}

function formatSummaryValue(value) {
  return value || '—';
}

function getLocalTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York';
  } catch (e) {
    return 'America/New_York';
  }
}

function formatReportType(type) {
  if (!type) return 'Custom Export';
  var meta = Report.getTypeMeta ? Report.getTypeMeta(type) : {};
  if (meta && meta.displayName) {
    return meta.displayName;
  }
  return String(type)
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/:/g, ' / ')
    .replace(/[_-]+/g, ' ')
    .trim();
}

function buildReportSummaryItems(report) {
  var items = [
    {
      label: 'Type',
      value: formatSummaryValue(formatReportType(report && report.type ? report.type : 'Custom Export'))
    }
  ];

  if (hasEnabledEventConfig(report)) {
    items.push({
      label: 'Latest event',
      value: report && report.latestEventStart
        ? moment(report.latestEventStart).format('M/D/YYYY, h:mm a')
        : 'No events yet'
    });
    items.push({
      label: 'Event status',
      value: report && report.latestEventStatus ? report.latestEventStatus : '—'
    });
  }

  return items;
}

function getCardDownloadFormat(report) {
  var type = report && report.type ? report.type : 'Custom Export';
  var formats = Report.getAllowedDownloadFormats ? Report.getAllowedDownloadFormats(type) : [];
  if (formats.indexOf('pdf') >= 0) return 'pdf';
  if (formats.indexOf('xlsx') >= 0) return 'xlsx';
  if (formats.indexOf('json') >= 0) return 'json';
  return (!report.type || report.type === 'Custom Export') ? 'xlsx' : 'pdf';
}

function getReportDownloadFormats(report) {
  var type = report && report.type ? report.type : 'Custom Export';
  var formats = Report.getAllowedDownloadFormats ? Report.getAllowedDownloadFormats(type) : [];
  if (formats.length) return formats;
  return (!report.type || report.type === 'Custom Export') ? ['xlsx'] : ['pdf', 'xlsx'];
}

function getDownloadButtonLabel(format) {
  if (format === 'xlsx') return 'Excel';
  if (format === 'json') return 'JSON';
  return 'PDF';
}

function getDownloadButtonIcon(format) {
  if (format === 'xlsx') return 'ion-document.green';
  if (format === 'json') return 'ion-code.blue';
  return 'ion-document.red';
}

function getTypeMeta(report) {
  var type = report && report.type ? report.type : 'Custom Export';
  return Report.getTypeMeta ? (Report.getTypeMeta(type) || {}) : {};
}

function getDownloadMeta(report) {
  var type = report && report.type ? report.type : 'Custom Export';
  if (Report.getDownloadMeta) {
    return Report.getDownloadMeta(type) || {};
  }
  var meta = getTypeMeta(report);
  return meta && meta.download ? meta.download : {};
}

function supportsEventEntrypoint(report) {
  var typeMeta = getTypeMeta(report);
  return Array.isArray(typeMeta.entrypoints) && typeMeta.entrypoints.indexOf('event') >= 0;
}

function shouldDefaultScheduleToEvent(report) {
  return Boolean(
    hasEnabledEventConfig(report)
    || supportsEventEntrypoint(report)
    || getDownloadMeta(report).requiresEvent
  );
}

function openScheduleDialogue(report) {
  if (!report || !report['@rid']) return;

  var type = report && report.type ? report.type : 'Custom Export';
  var downloadMeta = getDownloadMeta(report);
  var supportsEvent = supportsEventEntrypoint(report);
  var requiresEvent = Boolean(downloadMeta && downloadMeta.requiresEvent) && !supportsEvent;

  scheduledReportModal.editDialogue({
    modalTitle: 'Download ' + (report && report.name ? report.name : 'Report'),
    reportName: report && report.name ? report.name : null,
    reportRid: report && report['@rid'] ? report['@rid'] : null,
    reportType: type,
    sourceKind: 'reportRecord',
    downloadFormats: Report.getAllowedDownloadFormats
      ? Report.getAllowedDownloadFormats(type)
      : null,
    triggerType: shouldDefaultScheduleToEvent(report) ? 'event' : 'cron',
    downloadRequiresEvent: requiresEvent,
    supportsEventNotifications: hasEnabledEventConfig(report),
    timezone: getLocalTimezone(),
    span: DEFAULT_SCHEDULE_SPAN,
    resample: DEFAULT_SCHEDULE_RESAMPLE,
    format: getCardDownloadFormat(report)
  }, {
    lockTriggerType: requiresEvent
  });
}

function openDownloadDialogue(report) {
  if (!report || !report['@rid']) return;
  downloadReportModalInterface.editDialogue({
    modalTitle: 'Download ' + (report && report.name ? report.name : 'Report'),
    reportType: report && report.type ? report.type : 'Custom Export',
    reportRid: report['@rid'],
    reportRecord: report,
    sourceKind: 'reportRecord'
  });
}

function downloadLatestEvent(report) {
  if (!report || !report['@rid'] || !report.latestEventRid) return;

  var reportRid = String(report['@rid']).replace(/^#/, '');
  var format = getCardDownloadFormat(report);
  var query = new URLSearchParams({
    event: String(report.latestEventRid).replace(/^#/, ''),
    timezone: getLocalTimezone()
  }).toString();

  loadingModal.editDialogue('Downloading', 'We are generating the report, please wait.', true, true);

  loaders.requestWithLoader({
    loader: 'main',
    url: '/reports/' + reportRid + '/' + format + '/?' + query,
    method: 'GET',
    background: true,
  })
  .then(function (res) {
    if (res && res.status == 'ready') {
      return downloadResponseFiles(res).then(function () {
        loadingModal.close();
      });
    }
    throw new Error(res && (res.error || res.message) ? (res.error || res.message) : 'Report export failed');
  })
  .catch(function (err) {
    var message = err && err.message ? err.message : 'An error occured while processing your request';
    loadingModal.editDialogue('Error', message, false, false);
  });
}

reports.view = function() {
  var ctrl = this
  if (ctrl.requestStatus() !== RequestStatus.SUCCESS || !ctrl.reportFolder) {
    return m(requestStatusHandler, {
      requestStatus: ctrl.requestStatus,
      requestStatusCode: ctrl.requestStatusCode
    });
  }
  var canManageReports = auth.canManageReports();
  var showReportManagement = edit.vm.editing() || canManageReports;
  var label = m('div.flex.pb2', [
    m(m.route.Link, {href: '/reports', class: 'mr2'}, 'Reports'),
    ' / ',
    m('div.ml2', ctrl.reportFolder.name)
  ]);
  return m('div', [
    m(heading, {label: label, class: 'f-subheadline mh3 mb3 pb1 display'},[
      showReportManagement ? m(rowActionDropdown, {
        items: [
          {
            label: 'New Report',
            icon: 'ion-plus',
            onclick: () => {
              var ready = ctrl.reportTypesPromise || loadReportTypes();
              Promise.resolve(ready).then(function () {
                reportForm.editDialogue({parent: ctrl.reportFolder['@rid']});
              });
            }
          }
        ]
      }) : ''
    ]),
    m('div.cf', ctrl.reportFolder.children.map(function (report) {
      return m('div.fl.w-100.w-50-ns.ph3.fw3', [
        m('div.cf.bg-near-black.mv2.pa3.f3.relative', [
          m('div.flex.justify-between.items-start.mb2', [
            m('div.f2.fw5.pr3.flex-auto', report.name),
            showReportManagement ? m('div.tr.flex-none', [
              m(rowActionDropdown, {
                items: [
                  {
                    label: 'Edit Report',
                    icon: 'ion-ios-compose',
                    onclick: function () {
                      m.route.set('/report/' + report['@rid'].slice(1));
                    }
                  },
                  {
                    label: 'Delete Report',
                    icon: 'ion-ios-trash',
                    class: 'red',
                    onclick: reportForm.deleteDialogue.bind(reportForm, report)
                  }
                ]
              })
            ]) : null
          ]),
          m('div.flex.flex-wrap.mv3', buildReportSummaryItems(report).map(function (item) {
            var isLatestEventLink = item.label === 'Latest event'
              && report
              && report.type
              && report.type !== 'Custom Export'
              && report.latestEventRid
              && report.latestEventStart;
            return m('div.ba.b--white-10.br2.pa2.mr2.mb2.bg-black-20', { key: item.label }, [
              m('div.f7.gray.ttu.tracked', item.label),
              isLatestEventLink
                ? m('a.f5.mt1.db.blue.pointer.dim', {
                    onclick: function (ev) {
                      ev.preventDefault();
                      downloadLatestEvent(report);
                    }
                  }, item.value)
                : m('div.f5.mt1', item.value)
            ]);
          })),
          (() => {
            var hasDownloadableData = (report.type && report.type !== 'Custom Export') || report.hasChildrenDatasets;
            return m(button, {
              class: 'fr' + (hasDownloadableData ? '' : ' silver'),
              label: 'Download',
              func: hasDownloadableData ? openDownloadDialogue.bind(null, report) : undefined,
              icon: hasDownloadableData ? 'ion-document-text.blue' : 'ion-document.silver'
            });
          })()
        ]),
      ])
    })),
  ]);
};

module.exports = reports;
